import { FormControl } from '@angular/forms';
import { isString } from 'lodash';
import { GENERAL_CONSTANTS } from '../core/constants/General-constants';

export class EmailValidator {

  static isValid(control: FormControl) {

    let value = control.value;

    if (isString(value)) {
      value = value.toLowerCase();
    }

    const re = (GENERAL_CONSTANTS.PATTERN.EMAIL_VALIDATOR).test(value);

    if (re) {
      return null;
    }

    return {
      invalidEmail: true
    };

  }
}
